import { Pipe, PipeTransform } from "@angular/core";
import * as _ from 'lodash';
import { TranslateService } from "@ngx-translate/core";
import { map } from 'rxjs/operators';

@Pipe({ name: "customTranslate" })
export class CustomTranslatePipe implements PipeTransform {
   constructor(public translateService: TranslateService) { }

   transform(key: string, languageCode: string, interpolationParams?: Object) {
      /*      let currentLanguage: string = this.translateService.currentLang;
      
            this.translateService.currentLang = languageCode;
            this.translateService.use(languageCode);
            let translation: string = this.translateService.instant(key);
            this.translateService.currentLang = currentLanguage;
            this.translateService.use(currentLanguage);      
            return translation;*/

      return this.translateService.getTranslation(languageCode).pipe(
         map(translations => {
            return this.translateService.getParsedResult(translations, key, interpolationParams);
         })
      );
   }
}
